import { render, staticRenderFns } from "./WithdrawCompletePage.vue?vue&type=template&id=185cbec7&scoped=true&"
import script from "./WithdrawCompletePage.vue?vue&type=script&lang=js&"
export * from "./WithdrawCompletePage.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawCompletePage.vue?vue&type=style&index=0&id=185cbec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185cbec7",
  null
  
)

export default component.exports